module.exports = __webpack_public_path__ + "static/hj-45b0d85c4a24393b401f540b57a200ae.png";